export const northamptonMedicalPlanText = `Coverage for up to $1,200 in medical expenses for specified travel and
recreational accidents. For additional details, click here`;
